import React, { Fragment, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Customer from "../customer/Customer";
import { QUOTE_MODE_KEY } from "../../../_utils/quoteMode";

const PlaceOrder = ({handlePropertyClick}) => {

  const location = useLocation();

  // The property picker is shared by "Place an Order" (/place-order) and
  // "Generate New Quote" (/unit-quotes/new). Make the quote-mode flag
  // authoritative by route so a stale flag can never leak a normal order into
  // quote mode (or vice versa).
  useEffect(() => {
    if (location.pathname.startsWith("/unit-quotes")) {
      localStorage.setItem(QUOTE_MODE_KEY, "true");
    } else {
      localStorage.removeItem(QUOTE_MODE_KEY);
    }
  }, [location.pathname]);

  return (
    <Fragment>
			<Customer
				handlePropertyClick={true}
			/>
		</Fragment>
  )
}

export default PlaceOrder;
